<div class="form-content-item">
  <div class="form-header-item">
    <div>
      <h2 *ngIf="currentItem?.displayName">{{ currentItem.displayName }} [{{ currentItem.code }}]</h2>
    </div>
    <div *ngIf="showTopBtns && currentItem" class="div-btns-top">
      <action-bar (onSave)="saveWorkInspection()" (onDelete)="deleteWorkInspection()" [showSave]="isEditable" [showDelete]="isEditable"> </action-bar>
      <button mat-mini-fab class="action-button grey-button-color" [matMenuTriggerFor]="exportMenu" [matTooltip]="'work_inspection_export_tooltip' | translate" *ngIf="isExportable">
        <mat-icon>file_download</mat-icon>
      </button>
      <mat-menu #exportMenu="matMenu" class="export-menu-panel">
        <button mat-menu-item (click)="exportAsSevetp()">
          <mat-icon>save</mat-icon>
          <span>{{ 'work_inspection_export_sevetp' | translate }}</span>
        </button>
        <button mat-menu-item (click)="exportAsExcel()">
          <mat-icon>grid_on</mat-icon>
          <span>{{ 'work_inspection_export_excel' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <mat-tab-group *ngIf="currentItem" animationDuration="0ms" class="row title-margin-top" [selectedIndex]="tabSelectedIndex" #tabs (selectedTabChange)="onSelectedTabChange($event)">
    <mat-tab [label]="'work_inspection_tab_project' | translate">
      <app-work-inspection-project [currentItem]="currentItem" [wsAppPath]="wsAppPath"> </app-work-inspection-project>
    </mat-tab>

    <mat-tab [label]="'work_inspection_tab_solutions' | translate" *ngIf="currentItem && currentItem?.workInspectionId">
      <h3 class="title-margin-top">{{ 'work_inspection_solutions_title' | translate }}</h3>
      <div class="explanation-notice">
        <mat-icon>lightbulb_outline</mat-icon>
        <div class="explanation-content">
          <p [innerHTML]="'work_inspection_explanation_intro' | translate"></p>
          <ul>
            <li>
              <span [innerHTML]="'work_inspection_explanation_justify' | translate"></span>
              <mat-icon class="inline-icon">note_add</mat-icon>
              <span [innerHTML]="'work_inspection_explanation_justify_end' | translate"></span>
            </li>
            <li>{{ 'work_inspection_explanation_documents' | translate }}</li>
            <li>{{ 'work_inspection_explanation_export' | translate }}</li>
          </ul>
        </div>
      </div>
      <app-work-inspection-solutions
        *ngIf="originalSolution || verificationSolution"
        [originalSolution]="originalSolution"
        [verificationSolution]="verificationSolution"
        [activeIndicator]="indicators[indexEnergyToShow]"
        [allIndicators]="indicators"
        [wsAppPath]="wsAppPath"
        [versionId]="currentItem.versionId"
        (solutionChanged)="onSolutionUpdated($event)">
      </app-work-inspection-solutions>
    </mat-tab>
    <mat-tab [disabled]="!hasValidScenarioId">
      <ng-template mat-tab-label>
        <span [matTooltip]="!hasValidScenarioId ? scenarioTooltipMessage : ''" [matTooltipDisabled]="hasValidScenarioId"> {{ 'work_inspection_tab_scenario' | translate }} </span>
      </ng-template>
      <app-synthese
        *ngIf="isScenarioTabActivated && hasValidScenarioId"
        [scenario]="scenario"
        [scenarioId]="currentItem?.scenarioId"
        [hideTitle]="true"
        [hideBackButton]="true"
        [buttonsConfig]="syntheseButtonsConfig"
        [refreshKey]="scenarioRefreshKey">
      </app-synthese>
    </mat-tab>
  </mat-tab-group>
</div>
